/**
 * walleu-countdown
 * <walleu-countdown data-end="<epoch seconds>"> — keeps the server-rendered
 * digits ticking. On expiry it zeroes the digits, or removes itself when
 * data-hide-when-expired is present (the server already skips rendering
 * expired countdowns; this covers ends crossed mid-visit or cached pages).
 */
(function () {
  if (window.customElements.get('walleu-countdown')) return;

  class WalleuCountdown extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.dataset.end, 10) * 1000;
      if (!this.end) return;

      this.spans = {
        dd: this.querySelector('[data-dd]'),
        hh: this.querySelector('[data-hh]'),
        mm: this.querySelector('[data-mm]'),
        ss: this.querySelector('[data-ss]'),
      };

      this.tick();
      if (this.end > Date.now()) {
        this.interval = setInterval(() => this.tick(), 1000);
      }
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }

    tick() {
      const diff = this.end - Date.now();

      if (diff <= 0) {
        if (this.interval) clearInterval(this.interval);
        if (this.hasAttribute('data-hide-when-expired')) {
          this.remove();
          return;
        }
        this.render(0, 0, 0, 0);
        return;
      }

      let s = Math.floor(diff / 1000);
      const d = Math.floor(s / 86400);
      s -= d * 86400;
      const h = Math.floor(s / 3600);
      s -= h * 3600;
      const m = Math.floor(s / 60);
      s -= m * 60;
      this.render(d, h, m, s);
    }

    render(d, h, m, s) {
      const pad = (n) => String(n).padStart(2, '0');
      this.spans.dd.textContent = pad(d);
      this.spans.hh.textContent = pad(h);
      this.spans.mm.textContent = pad(m);
      this.spans.ss.textContent = pad(s);
    }
  }

  customElements.define('walleu-countdown', WalleuCountdown);
})();
